<div [ngClass]="{
        'hide-select-in-table': closeComponent,
        'select-in-table-extra-margin': !enableDelete,
        'select-in-table-expired': showExpired,
        'edition': showInputBoxes || showDateInput
    }"
  [ngStyle]="!showExpired && {'border-color': styleObject.border, 'color': styleObject.text}"
  class="select-in-table-wrapper"
  data-cy="select-in-table-wrapper">

  @if (showInputBoxes) {
    <div class="select-in-table-edition">
      <div #dropdown='ngbDropdown' [autoClose]="autoClose" class="ngbdropdown-wrapper"
        ngbDropdown>
        <button class="select-in-table-toggle"
          data-cy="select-in-table-toggle-button"
          ngbDropdownToggle>
          <span class="select-in-table-text">
            <app-tooltip [disable]="!selectedOptionHasTooltip" [dynamic]="false"
              [message]="selectedOption.tooltip">
              <span [ngClass]="{'placeholder': isPlaceholder}"
              data-cy="select-in-table-toggle-placeholder">{{placeholderLabel}}</span>
            </app-tooltip>
          </span>
                <span [ngClass]="{
                    'iwp-icon-gen_arrow_down': !dropdown.isOpen(),
                    'iwp-icon-gen_arrow_up': dropdown.isOpen()
                    }"
          data-cy="select-in-table-toggle-arrow"></span>
        </button>
        @if (dropdownType === dropdownTypeEnum.DESCRIPTION) {
          <app-description-dropdown (selectedOption)="setDescriptionSelectedOption($event)"
            [dropdownOptions]="dropdownOptions"
          [showDescription]="true"></app-description-dropdown>
        }
        @if (dropdownType === dropdownTypeEnum.TREE) {
          <app-tree-dropdown (selectedOption)="setTreeSelectedOption($event)"
          [dropdownOptions]="dropdownOptions"></app-tree-dropdown>
        }
        @if (dropdownType === dropdownTypeEnum.CODE) {
          <app-description-dropdown
            (selectedOption)="setDescriptionSelectedOption($event)"
            [dropdownOptions]="dropdownOptions"
            [dropdownTooltip]="dropdownTooltip"
            [showDescription]="false"
          [useCodeOrName]="useCodeOrName"></app-description-dropdown>
        }
      </div>
    </div>
  }

  <div class="select-in-table-content"
    data-cy="select-in-table-selected-display">
    <app-tooltip [disable]="displayObject.tooltip == null"
      [dynamic]="false"
      [message]="displayObject.tooltip">
      @if (!showInputBoxes) {
        <span data-cy="select-in-table-code">{{displayObject.string}}</span>
      }
    </app-tooltip>

    @if (willExpire) {
      <div class="select-in-table-clock-wrapper">
        <app-tooltip [dynamic]="false"
          message="This role will expire in {{displayObject.expirationDate | date: 'yyyy-MM-dd'}}">
          <span class="iwp-icon-gen_time select-in-table-warning"
          data-cy="select-in-table-warning-icon"></span>
        </app-tooltip>
      </div>
    }

    @if (displayObject.expirationDate && !showDateInput) {
      <div
             [ngClass]="{
                 'select-in-table-expired': showExpired,
                 'select-in-table-warning': willExpire
             }"
        [ngStyle]="!showExpirationWarning() && {'color': styleObject.secondaryText}"
        class="select-in-table-date display"
        data-cy="select-in-table-date">
        <span>{{displayObject.expirationDate | date: 'dd-MM-yyyy'}}</span>
      </div>
    }

  </div>

  @if (showDateInput) {
    <div class="select-in-table-date">
      <app-input-date #dateInput
        (closedDatepicker)="preventCloseOnDatepickerClick()"
        (inputValueChange)="setDatepickerValue($event)"
        [alternateBackground]="true"
        [expiringDate]="willExpire"
        [maxDate]="setDateRange().maxDate"
        [minDate]="setDateRange().minDate"
        baseCypressTag="select-in-table-datepicker-text">
      </app-input-date>
    </div>
  }

  @if (enableDelete) {
    <button #closeButton
      [ngClass]="{'hide-close-button': !showInputBoxes}"
      class="select-in-table-close">
      <span (click)="closeClick()" class="iwp-icon-gen_close_s" data-cy="select-in-table-close-button"></span>
    </button>
  }
</div>

